var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedDairy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000732422,
    width: 40,
    height: 39.999,
    rx: 19.9995,
    fill: "#EBF5FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3906 23.8712V21.5812C19.3886 18.3454 18.5926 15.1585 17.0727 12.3016C17.2857 12.2206 17.4687 12.0786 17.5977 11.8916C17.7277 11.7057 17.7957 11.4837 17.7957 11.2557V10.4347C17.7957 10.1377 17.6777 9.85375 17.4687 9.64476C17.2597 9.43477 16.9757 9.31677 16.6777 9.31677H12.9219C12.6249 9.31677 12.3399 9.43477 12.1319 9.64476C11.9219 9.85275 11.8029 10.1377 11.8029 10.4347V11.2557C11.8029 11.4837 11.8729 11.7057 12.0019 11.8916C12.1319 12.0786 12.3139 12.2216 12.5269 12.3016C11.007 15.1585 10.211 18.3454 10.209 21.5812V29.1489C10.209 29.6289 10.477 30.2729 11.3339 30.2729H17.1977",
    stroke: "#1F5B8F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8716 24.7061C17.8716 24.7061 24.4653 21.4772 24.9703 21.2282C25.4773 20.9792 26.4292 20.6793 27.0002 21.2282C27.5702 21.7762 28.8421 22.9482 29.1911 23.2472C29.5391 23.5471 29.7891 24.1691 29.7891 24.7061C29.7891 24.7061 29.7891 28.6829 29.7891 29.0069C29.7891 29.3299 29.6891 30.0539 29.0661 30.1529C28.4421 30.2529 18.5996 31.2248 18.2726 31.2498C17.9456 31.2748 17.1986 30.9258 17.1986 30.1039C17.1986 29.2819 17.1986 26.688 17.1986 26.214C17.1986 25.515 17.3776 24.9471 17.8716 24.7061Z",
    stroke: "#1F5B8F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7216 24.992L29.5561 23.8711",
    stroke: "#1F5B8F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9223 28.2199C25.3559 28.2199 25.7073 27.8684 25.7073 27.4349C25.7073 27.0014 25.3559 26.6499 24.9223 26.6499C24.4888 26.6499 24.1373 27.0014 24.1373 27.4349C24.1373 27.8684 24.4888 28.2199 24.9223 28.2199Z",
    stroke: "#1F5B8F",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9264 30.4859C22.3539 30.4859 22.7004 30.1394 22.7004 29.7119C22.7004 29.2844 22.3539 28.9379 21.9264 28.9379C21.499 28.9379 21.1524 29.2844 21.1524 29.7119C21.1524 30.1394 21.499 30.4859 21.9264 30.4859Z",
    stroke: "#1F5B8F",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1476 27.003C20.7026 27.003 21.1525 26.5531 21.1525 25.998C21.1525 25.443 20.7026 24.993 20.1476 24.993C19.5925 24.993 19.1425 25.443 19.1425 25.998C19.1425 26.5531 19.5925 27.003 20.1476 27.003Z",
    stroke: "#1F5B8F",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6462 27.56C29.1488 27.56 29.5562 27.1526 29.5562 26.65C29.5562 26.1474 29.1488 25.74 28.6462 25.74C28.1436 25.74 27.7362 26.1474 27.7362 26.65C27.7362 27.1526 28.1436 27.56 28.6462 27.56Z",
    stroke: "#1F5B8F",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0047 12.2185H17.1987",
    stroke: "#1F5B8F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1589 16.3434C11.5249 16.3894 11.7338 16.5384 11.9898 16.7174C12.3408 16.9624 12.7358 17.2384 13.5038 17.2384C14.2717 17.2384 14.6687 16.9624 15.0187 16.7174C15.3307 16.4994 15.5777 16.3274 16.1147 16.3274C16.6506 16.3274 16.8976 16.4994 17.2086 16.7174C17.5136 16.9294 17.8536 17.1684 18.4426 17.2264",
    stroke: "#1F5B8F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedDairy);
export default __webpack_public_path__ + "static/media/rounded-dairy.bfa7980f62de333b5b9247d77f696035.svg";
export { ForwardRef as ReactComponent };